
/**
 * Module dependencies.
 */

import Footer from 'src/components/footer';
import KioskNavbar from 'src/components/kiosk/navbar';
import Navbar from 'src/components/navbar';
import NewsletterCta from 'src/components/newsletter-cta';
import PageTransition from 'src/components/page-transition';
import React, { ReactElement, ReactNode } from 'react';

/**
 * `Props` type.
 */

type Props = {
  children: ReactNode,
  isKiosk?: boolean
};

/**
 * `Layout` component.
 */

const Layout = ({ children, isKiosk }: Props): ReactElement => (
  <>
    {isKiosk ? <KioskNavbar /> : <Navbar />}

    <PageTransition>
      <main id={'main-content'}>
        {children}
      </main>

      {!isKiosk && (
        <>
          <NewsletterCta />

          <Footer />
        </>
      )}
    </PageTransition>
  </>
);

/**
 * Export `Layout` component.
 */

export default Layout;
